import DissolveModal from './DissolveModal.container'

export default DissolveModal
